import { usePaginatedQuery } from "convex/react";

import { employeesGetAll } from "~/api-refs";
import { DataTable } from "~/components/ui/data-table";

import { employeeTableColumns } from "./employee-list-table-columns";
import { EmployeeTableToolbar } from "./employee-list-table-toolbar";

export function EmployeesList() {
  const { results } = usePaginatedQuery(
    employeesGetAll,
    {},
    { initialNumItems: 100 }
  );

  return (
    <DataTable
      columns={employeeTableColumns}
      data={results?.length ? results : []}
      id="employeesTable"
      toolbar={(table) => <EmployeeTableToolbar table={table} />}
    />
  );
}
